import React from "react";
import FAQimage from "../../../assets/faq.png"
import { useEffect } from "react";


const FAQHome = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
        
      }, [])

    return (
        
    <div class="bg-white dark:bg-gray-700">
        <div class="border-b dark:border-gray-700">
        <ul class="circles">
        <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
      </ul>
            <div class="container m-auto px-6 pt-24 md:px-12  lg:pt-[4.8rem] lg:px-7">
                <div class="grid lg:grid-cols-2 items-center gap-12 px-2 md:px-0">
                    <div class="col-span-1">
                    <div class="hidden lg:flex flex-col items-center justify-center w-full h-full mt-10 relative lg:pr-10  ">
          <img src={FAQimage} class="
          w-[48rem] max-w-none sm:w-[57rem] md:-ml-4 lg:-ml-0"   width={2432}
                                height={1442}/>
        </div>
                    </div>
    
                    <div class="relative col-span-1">
                        <h1 class="font-bold text-5xl sm:text-6xl md:text-7xl xl:text-8xl dark:text-white">A Look for every <span
                                class="text-cyan-800 dark:text-cyan-400 ">Concern</span>.</h1>
                        <div class="mt-8 lg:mt-16 space-y-8">
                            <p class="text-gray-700 dark:text-gray-300 text-xl font-['Maven Pro'] tracking-widest leading-loose">Share any concerns you may have, as we have a specialized team ready to assist you with your inquiries.</p>
                           
                        </div>'
                    </div>
                </div>
            </div>
        </div>
    </div>
                                        
    )
}

export default FAQHome;